export default __webpack_public_path__ + "static/virsat-logo-9e9712b3e645820ccce9832f4b01e4ed.svg";